<template>
<div id="sidebar">
  <div class="logo level">
    <div class="level-left">
      <a href="/">
        <svgicon class="level-item" name="logo" width="82" height="35" :original="true"></svgicon>
      </a>
      <a href="/" class="level-item logo-text">GamePlan</a>
    </div>
    <a @click="toggle()" class="level-right">
      <svgicon class="level-item digita" name="menu" height="30" width="30"></svgicon>
    </a>
  </div>
  <aside class="menu" v-for="section in sections" :key="section.name">
    <p class="menu-label">
      {{ section.name }}
    </p>
    <ul class="menu-list">
      <li>
        <ul>
          <li v-for="link in section.links" :key="link.label">
            <router-link
              v-if="link.name"
              :class="{'is-active': activeSection === link.label }"
              :to="{ name: link.name }">
              <level-left>
                <svgicon class="level-item" :name="link.image" width="30" height="30"></svgicon>
                <p class="level-item">{{ link.label}}</p>
              </level-left>
            </router-link>
            <a v-else :href="link.url" target="_">
              <level-left>
                <svgicon class="level-item" :name="link.image" width="30" height="30"></svgicon>
                <p class="level-item">{{ link.label}}</p>
              </level-left>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </aside>
  <a href="https://digitasecurity.com" class="digita-logo level" target="_">
    <span class="center">
      <svgicon class="level-item" name="shield" width="25" height="25"></svgicon> Digita Security
    </span>
  </a>
</div>
</template>

<script>
import { mapState } from 'vuex';
import LevelLeft from '@/components/LevelLeft.vue';

export default {
  name: 'SideBarLarge',
  components: { LevelLeft },
  computed: {
    ...mapState('route', ['name']),
    ...mapState(['activeSection']),
  },
  data() {
    return {
      large: true,
    };
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggle() {
      this.$emit('update:toggleSideBarLarge');
    },
  },
  watch: { },
};
</script>

<style lang="scss" scoped>

#sidebar2 {
  width: 60px;
}

a.digita-logo {
  position: absolute;
  bottom: .5rem;
  margin: 0 auto;
  width: 15rem;
  .center {
    margin: 0 auto;
  }
  svg {
    margin-right: 0;
  }
}

#sidebar, #sidebar-small {
  background-color: $navbar-background;
  border-right: 1px solid $border-color;
}

.logo {
  height: $navbar-height;
  border-bottom: 1px solid $border-color;
  text-align: center;
  margin-bottom: 0;
  background-color: $navbar-background;

  .level-right {
    margin-right: $content-padding;
  }

  .level-left {
    // margin: 0 auto;

    img {
      margin-right: 0;
    }

    a {
      font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-weight: 500;
      color: $link-color;
    }
  }
}

aside {
  padding: .25rem .5rem;

  .menu-label {
    color: $expression-background;
  }

  .menu-list {
    li {
      ul {
        margin: 0 .75rem;
      }
    }

    a {
      color: $font-color;
      border-radius: 0;
      padding: 0;
    }

    a:hover {
      background-color: $border-color;
    }

    a.is-active {
      background-color: $sidebar-active;
    }
  }
}
</style>
